// Queries contributing to modernization path calculations
const QUERY_GRID_PARAMS = "Contains Grid Parameters";
const QUERY_QS_STAGES   = "QualityStage Stages";
const QUERY_BASIC_CODE  = "Contains BASIC Code";
const QUERY_NON_DFD     = "Stages Unsupported by DataStage Flow Designer";
const QUERY_EXT_ADDRESS = "External Address Cleanse Stages";
const QUERY_PACK_STAGES = "Pack Stages";
const QUERY_SPARK_JOBS  = "Spark jobs";

const MODERNIZATION_FACTORS = {
    "Pack Stages": {
        name: "Pack Stages",
        path: 5,
        contributors: [
            {
                name: QUERY_PACK_STAGES,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "Spark jobs": {
        name: "Spark jobs",
        path: 5,
        contributors: [
            {
                name: QUERY_SPARK_JOBS,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "External Address Cleanse Stages": {
        name: "External Address Cleanse Stages",
        path: 5,
        contributors: [
            {
                name: QUERY_EXT_ADDRESS,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "Grid jobs with non-DFD stages": {
        name: "Grid jobs with non-DFD stages",
        path: 4,
        contributors: [
            {
                name: QUERY_GRID_PARAMS,
                type: "query",
                shouldMatch: true
            },
            {
                name: QUERY_NON_DFD,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "Parallel jobs with non-DFD stages": {
        name: "Parallel jobs with non-DFD stages",
        path: 3,
        contributors: [
            {
                name: "PARALLEL_JOB",
                type: "assetType",
            },
            {
                name: QUERY_NON_DFD,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "QualityStage Stages": {
        name: "QualityStage Stages",
        path: 3,
        contributors: [
            {
                name: QUERY_QS_STAGES,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "Data Quality Specification": {
        name: "Data Quality Specification",
        path: 3,
        contributors: [
            {
                name: "DATA_QUALITY_SPECIFICATION",
                type: "assetType",
            }
        ]
    },
    "Job Sequences with BASIC code": {
        name: "Job Sequences with BASIC code",
        path: 3,
        contributors: [
            {
                name: "SEQUENCE_JOB",
                type: "assetType",
            },
            {
                name: QUERY_BASIC_CODE,
                type: "query",
                shouldMatch: true
            }
        ]
    },
    "Server Jobs": {
        name: "Server Jobs",
        path: 2,
        contributors: [
            {
                name: "SERVER_JOB",
                type: "assetType",
            }
        ]
    },
    "Server Shared Container": {
        name: "Server Shared Container",
        path: 2,
        contributors: [
            {
                name: "SERVER_SHARED_CONTAINER",
                type: "assetType",
            }
        ]
    },
    "Server Routine": {
        name: "Server Routine",
        path: 2,
        contributors: [
            {
                name: "SERVER_ROUTINE",
                type: "assetType",
            }
        ]
    },
    "Job Sequences without BASIC code": {
        name: "Job Sequences without BASIC code",
        path: 2,
        contributors: [
            {
                name: "SEQUENCE_JOB",
                type: "assetType",
            },
            {
                name: QUERY_BASIC_CODE,
                type: "query",
                shouldMatch: false
            }
        ]
    },
    "Parallel Jobs with only DFD compatible stages": {
        name: "Parallel Jobs with only DFD compatible stages",
        path: 1,
        contributors: [
            {
                name: "PARALLEL_JOB",
                type: "assetType",
            },
            {
                name: QUERY_NON_DFD,
                type: "query",
                shouldMatch: false
            }
        ]
    },
    "Parallel Shared Containers": {
        name: "Parallel Shared Containers",
        path: 1,
        contributors: [
            {
                name: "PARALLEL_SHARED_CONTAINER",
                type: "assetType",
            }
        ]
    },
    "Parameter Sets": {
        name: "Parameter Sets",
        path: 1,
        contributors: [
            {
                name: "PARAMETER_SET",
                type: "assetType",
            }
        ]
    }
};

export default MODERNIZATION_FACTORS;